import { APP_V2_USER_EVENTS, useLogEffect } from "@src/appV2/lib/analytics";

import { useCurrentUserId } from "./useCurrentUserId";
import { useHomeHealthSurface } from "./useHomeHealthSurface";

// Fire HH page-view events once on mount, tagged with the mobile/desktop surface.
export function useLogHomeHealthCasesListViewed(): void {
  const workplaceId = useCurrentUserId();
  const renderedSurface = useHomeHealthSurface();

  useLogEffect(APP_V2_USER_EVENTS.HOME_HEALTH_CASES_LIST_VIEWED, { renderedSurface, workplaceId });
}

export function useLogHomeHealthCaseDetailViewed(caseId: string | undefined): void {
  const workplaceId = useCurrentUserId();
  const renderedSurface = useHomeHealthSurface();

  useLogEffect(APP_V2_USER_EVENTS.HOME_HEALTH_CASE_DETAIL_VIEWED, {
    renderedSurface,
    workplaceId,
    caseId,
  });
}
